import { Pipe } from '@angular/core';
import type { PipeTransform } from '@angular/core';

/**
 * Formats phone number.
 * For example:
 * converts 4165551234 -> (416) 555-1234
 * converts 14165551234 -> 1 (416) 555-1234
 */
@Pipe({
  name: 'tdWbPhone'
})
export class PhonePipe implements PipeTransform {

  transform(value: string | undefined): string {
    let country: string;
    let areaCode: string;
    let countryCodeLength: number;
    let localNumber: string;

    if (typeof value === 'string' && value.length > 0) {
      country = '';
      areaCode = '';
      countryCodeLength = 0;
      localNumber = '';

      value = value.trim();

      if (value.length >= 10 ) {
        countryCodeLength = value.length - 10;  // country could be 0-3 digits
        // chop off the country code now that we know how long it is
        country = value.slice(0, countryCodeLength);
      }
      if (value.length > 7 ) {
        areaCode = value.substring(countryCodeLength, countryCodeLength + 3);  // chop off the area code
      }
      if (value.length < 7) {
        localNumber = value;
      } else {
        // chop off the 7 digit number
        localNumber = value.substring((countryCodeLength + areaCode.length), (countryCodeLength + areaCode.length + 7));
        localNumber = localNumber.slice(0, 3) + '-' + localNumber.slice(3);
      }
      if (areaCode !== '') {
        areaCode = ' (' + areaCode + ') ';
      }
      return (country + areaCode + localNumber).trim();
    }
    return '';  // return empty string if no value provided
  }
}
